var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97238 3.74298C9.97644 3.81998 9.97644 3.89348 9.97644 3.97048C9.9805 6.30499 7.91714 9 4.14379 9C3.03087 9 1.93826 8.7235 1 8.2055C1.16247 8.223 1.32494 8.23 1.48741 8.23C2.40942 8.23 3.30707 7.964 4.03412 7.4705C3.15678 7.4565 2.38505 6.96299 2.11698 6.24199C2.42567 6.29449 2.74249 6.28399 3.04305 6.21049C2.08855 6.04949 1.40211 5.32499 1.39805 4.48149C1.39805 4.47449 1.39805 4.46749 1.39805 4.46049C1.68237 4.59699 2.00325 4.67399 2.32819 4.68099C1.43054 4.16298 1.15028 3.13048 1.69456 2.32198C2.73842 3.42798 4.27376 4.09648 5.92283 4.16998C5.7563 3.55748 5.98375 2.91348 6.51584 2.47948C7.34037 1.81098 8.64013 1.84598 9.41998 2.55648C9.87896 2.47948 10.3217 2.33248 10.7238 2.12598C10.5695 2.53548 10.2486 2.88198 9.8221 3.10248C10.2283 3.06048 10.6263 2.96598 11 2.82598C10.7238 3.18298 10.3745 3.49098 9.97238 3.74298Z",
    fill: "#1D9BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.f7b3e2f5d98a1e66baf1eeb8a429f4ab.svg";
export { ForwardRef as ReactComponent };